import React from "react";

export const LOGO_TITLE = "SellBot AiML";
export const LOGO_SUB_TITLE = "Operator Conversations";
export const APP_TITLE = LOGO_TITLE;
export const APP_TAGLINE =
  "Escalated shopper conversations, team handoff, and operator replies in one workspace.";
export const LOGIN_TITLE = "MultiChannel Inbox";
export const LOGIN_TITLE_SUBLINE = "with live handoff";
export const LOGIN_SUB_TITLE =
  "Sign in to review escalations, reply as a human, and manage customer conversations under the SellBot AiML brand.";

interface AppLogoProps {
  decorative?: boolean;
  title?: string;
}

export const AppLogo: React.FC<AppLogoProps> = ({
  decorative = false,
  title = "app logo",
}) => (
  <img
    src={`${process.env.PUBLIC_URL}/sellbotaiml-profile-pic.png`}
    alt={decorative ? "" : title}
    aria-hidden={decorative}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "12px",
      display: "block",
    }}
  />
);
